export default {
  computed: {
    currentResource() {
      if (this.currentQuery.nav) {
        const navigationItemsList = this.$store.getters['navigationItems/navigationItemsList'];
        // Get last resource in query list
        const query = this.currentQuery.nav.split(',').slice(0).pop();
        // length check on query needed to prevent home being labeled as default query (home has no query)
        return navigationItemsList.find(ni => query.length > 1 && ni.query === query) || {};
      }
      return {};
    },
    currentQuery() {
      const query = {};
      if (this.$route.query.nav) {
        query.nav = this.$route.query.nav;
      }
      return query;
    },
    currentYear() {
      return (new Date()).getFullYear();
    },
    months() {
      return [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];
    },
    years() {
      const year = new Date().getFullYear();
      const years = [0, 1, 2, 3, 4, 5].map(n => n + year);
      return years;
    },
  },
  methods: {
    nestedQuery(navigationItem) {
      let query = navigationItem.query;
      if (query) {
        query = this.currentQuery.nav + ',' + query;
      }

      return { ...this.currentQuery, nav: query };
    },
  },
};
